import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import CustomerGateway from '~apis/customer';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchExportCustomerListing(api: CustomerGateway): SagaWatcherReturnType {
    yield takeEvery('customer/customerExportCustomerListingAttempt', handleExportCustomerListing, api);
}

function* handleExportCustomerListing(api: CustomerGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.exportCustomerListing], { authToken });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.customerExportCustomerListingFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.customerExportCustomerListingSuccess(response.data));
    }
}
